import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { StateSwitcher } from 'containers/misc'
import { AJ_PROGRESS_STATES, AJ_EVENT_TYPES } from 'constants/enums'

export default class AjState extends Component {
  static propTypes = {
    ajEventId: PropTypes.number.isRequired,
    ajEventState: PropTypes.object.isRequired,
    changeAjParticipantEventState: PropTypes.func.isRequired,
    approvalComponent: PropTypes.object,
    signoffComponent: PropTypes.object,
    ajEventGeneral: PropTypes.object,
    ajEventCategory: PropTypes.string
  }
  static defaultProps = {
    ajEventState: {}
  }

  render() {
    const {
      ajEventState,
      changeAjParticipantEventState,
      ajEventId,
      approvalComponent,
      signoffComponent,
      ajEventGeneral,
      ajEventCategory
    } = this.props

    const disabledStates = [
      AJ_PROGRESS_STATES.ajSetup.id,
      AJ_PROGRESS_STATES.ajOfficeSignoff.id,
      AJ_PROGRESS_STATES.ajCeremonySignoff.id,
      AJ_PROGRESS_STATES.ajComplete.id,
      AJ_PROGRESS_STATES.ajInactive.id
    ]

    const assessorApprovalKey =
      ajEventCategory === AJ_EVENT_TYPES.practice.id
        ? 'states.supervisor_approval'
        : 'states.assessor_approval'

    const states = {
      [AJ_PROGRESS_STATES.ajSetup.id]: {
        id: AJ_PROGRESS_STATES.ajSetup.id,
        label: 'Setup',
        intlKey: 'states.setup',
        content: ajEventGeneral,
        disabledStates: ['DISABLED']
      },
      [AJ_PROGRESS_STATES.ajApproval.id]: {
        id: AJ_PROGRESS_STATES.ajApproval.id,
        label: 'Journey approval',
        intlKey: 'states.journey_approval',
        content: approvalComponent,
        disabledStates: ['DISABLED']
      },
      [AJ_PROGRESS_STATES.ajInProgress.id]: {
        id: AJ_PROGRESS_STATES.ajInProgress.id,
        label: 'In progress',
        intlKey: 'states.in_progress',
        content: ajEventGeneral,
        disabledStates: [
          AJ_PROGRESS_STATES.ajLeaderSignoff.id,
          ...disabledStates
        ]
      },
      [AJ_PROGRESS_STATES.ajAssessorApproval.id]: {
        id: AJ_PROGRESS_STATES.ajAssessorApproval.id,
        label: 'Assessor approval',
        intlKey: assessorApprovalKey,
        content: ajEventGeneral,
        disabledStates: [AJ_PROGRESS_STATES.ajApproval.id, ...disabledStates]
      },
      [AJ_PROGRESS_STATES.ajLeaderSignoff.id]: {
        id: AJ_PROGRESS_STATES.ajLeaderSignoff.id,
        label: 'Section sign-off',
        intlKey: 'states.section_signoff',
        content: signoffComponent,
        disabledStates: ['DISABLED']
      },
      [AJ_PROGRESS_STATES.ajOfficeSignoff.id]: {
        id: AJ_PROGRESS_STATES.ajOfficeSignoff.id,
        label: 'Office sign-off',
        intlKey: 'states.office_signoff',
        content: ajEventGeneral,
        disabledStates: [
          AJ_PROGRESS_STATES.ajApproval.id,
          AJ_PROGRESS_STATES.ajInProgress.id,
          AJ_PROGRESS_STATES.ajAssessorApproval.id,
          ...disabledStates
        ]
      },
      [AJ_PROGRESS_STATES.ajComplete.id]: {
        id: AJ_PROGRESS_STATES.ajComplete.id,
        label: 'Completed',
        intlKey: 'states.completed',
        content: ajEventGeneral,
        disabledStates: ['DISABLED']
      },
      [AJ_PROGRESS_STATES.ajCeremonySignoff.id]: {
        id: AJ_PROGRESS_STATES.ajCeremonySignoff.id,
        label: 'Ceremony',
        intlKey: 'states.ceremony',
        content: ajEventGeneral,
        disabledStates: ['DISABLED']
      },
      [AJ_PROGRESS_STATES.ajInactive.id]: {
        id: AJ_PROGRESS_STATES.ajInactive.id,
        label: 'Inactive',
        intlKey: 'states.inactive',
        content: null,
        disabledStates: ['DISABLED']
      }
    }

    return (
      <StateSwitcher
        id={ajEventId}
        state={ajEventState}
        states={states}
        changeState={changeAjParticipantEventState}
      />
    )
  }
}
